import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../../styles/proposition-bets-widget.module.scss";

export const PropositionBetsWidgetRowAthleteDetails = observer(({row}) => {
  return (
    <div className={classNames(styles.athlete_details)}>
      <div className={classNames(styles.athlete_name)}>{row.athlete.name}</div>
      {
        row.secondaryName
      }
    </div>
  )
});
